import { get, post } from '../utils/http'
class Login {
  async getLoginSmsCode(params, data) {
    const res = await get(`/api/content/v1/sms/getLoginSmsCode/${params}`, data)
    return res.data
  }
  async swjjPcUserRegister(params) {
    const res = await post(`/api/auth/v1/token/swjjPcUserRegister`, params)
    return res.data
  }
  async swjjPcUserLogin(params) {
    const res = await post(`/api/auth/v1/token/swjjPcUserLogin`, params)
    return res.data
  }
  async resetUserPassword(params) {
    const res = await post(`/api/user/v1/scenic/user/resetUserPassword`, params)
    return res.data
  }
  async updateUserPassword(params) {
    const res = await post(
      `/api/user/v1/scenic/user/updateUserPassword`,
      params
    )
    return res.data
  }
  async SwjjUserInfo(params) {
    const res = await get(`/api/user/v1/scenic/user/getSwjjUserInfo`, params)
    return res.data
  }
  async updateUserInfo(params) {
    const res = await post(`/api/user/v1/scenic/user/updateUserInfo`, params)
    return res.data
  }
}
export default new Login()
